import { render, staticRenderFns } from "./feedAuditSub.vue?vue&type=template&id=194d648d&scoped=true"
import script from "./feedAuditSub.vue?vue&type=script&lang=js"
export * from "./feedAuditSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194d648d",
  null
  
)

export default component.exports